import React, { forwardRef } from 'react';
import defaultLogo from './logo.png';

const InvoicePreview = forwardRef(({ data }, ref) => {
  // Logic & Calculations
  const subtotal = (data.items || []).reduce((sum, i) => sum + (Number(i.rate) * Number(i.qty)), 0);
  const vatAmount = (subtotal- Number(data.discount)) * ((Number(data.vatRate) || 0)) / 100;
  const grandTotal = (subtotal  - (Number(data.discount)) + vatAmount || 0);
  const amountPaid = (data.transactions || []).reduce((sum, p) => sum + Number(p.amount), 0);
  const currentBalance = grandTotal - amountPaid;


 
const formatDate = (dateStr) => {
        if (!dateStr) return "";
        let date = new Date(dateStr);
        // Add 1 day
        date.setDate(date.getDate() + 1);
        // Extract parts using Local Time (respects your UTC+6 offset)
  const d = String(date.getDate()).padStart(2, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const y = date.getFullYear();

  // Returns clean "19/03/2026"
  return `${d}/${m}/${y}`;
      };

  // Formatting helpers
  const formatDateT = (dateStr) => {
  if (!dateStr) return "";
  
  // Create the date object from your database string
  const date = new Date(dateStr);
  
  // Safety check for invalid dates
  if (isNaN(date.getTime())) return "";

  // Extract components using Local Time (respects UTC+6)
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  // Return exactly as 30/12/2026
  return `${day}/${month}/${year}`;
};

  return (
    <div ref={ref} style={{ 
      width: '210mm', minHeight: '297mm', background: '#fff', 
      padding: '0', boxSizing: 'border-box', position: 'relative', 
      color: '#2c3e50', fontFamily: 'Arial, sans-serif'
    }}>
      
      {/* Header Branding Area */}
      <div style={{ display: 'flex', background: '#f8f5fe', color: '#160E44', padding: '30px 10mm' }}>
        <div style={{ flex: 2 }}>
          {data.companyFooter ? (
            <img src={defaultLogo} alt="Logo" style={{ maxHeight: '60px' }} />
          ) : (
            <div style={{ fontSize: '18pt', fontWeight: '900', letterSpacing: '1.5px' }}>
              {(data.company || "COMPANY").split(' ')[0]}
            </div>
          )}
          <p style={{ margin: '8px 0 0 0', opacity: 0.8, fontSize: '8.5pt', maxWidth: '280px', lineHeight: '1.4' }}>
            Professional Business Solutions & Digital Services
          </p>
        </div>
        <div style={{ flex: 1, textAlign: 'right' }}>
          <h1 style={{ fontSize: '16pt', margin: 0, fontWeight: '800', letterSpacing: '-1px', color: '#662d91' }}>INVOICE</h1>
          <p style={{ margin: 0, fontSize: '10pt', fontWeight: '600', color: '#295d80' }}>Invoice No. {data.invoiceNo}</p>
        </div>
      </div>

      {/* Info Grid */}
      <div style={{ padding: '15mm 20mm' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '30px', marginBottom: '35px' }}>
          <div>
            <h4 style={{ textTransform: 'uppercase', fontSize: '8pt', color: '#7f8c8d', letterSpacing: '1px', marginBottom: '10px' }}>Billed to:</h4>          
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '5px' }}>
                <span style={{ fontSize: '10pt', fontWeight: '800', color: '#34495e' }}>Client Name:</span>
                <span style={{ fontSize: '10pt', fontWeight: '700', color: '#5900ff' }}>{data.clientName}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '5px', marginTop: '4px' }}>
                <span style={{ fontSize: '10pt', fontWeight: '800', color: '#34495e' }}>Company Name:</span>
                <span style={{ fontSize: '10pt', fontWeight: '700', color: '#5900ff' }}>{data.company}</span>
            </div>
            <p style={{ margin: '10px 0 0 0', color: '#7f8c8d', fontSize: '9pt', lineHeight: '1.5', width: '280px', fontWeight: '500' }}>{data.address}</p>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', background: '#f8f9fa', padding: '15px', borderRadius: '6px', alignSelf: 'start' }}>
            <div>
              <h4 style={{ margin: '0 0 4px 0', fontSize: '7pt', color: '#7f8c8d', textTransform: 'uppercase' }}>Date Issued</h4>
              <p style={{ margin: 0, fontSize: '9pt', fontWeight: '700' }}>{formatDate(data.issueDate)}</p>
            </div>
            <div>
              <h4 style={{ margin: '0 0 4px 0', fontSize: '7pt', color: '#7f8c8d', textTransform: 'uppercase' }}>Due Date</h4>
              <p style={{ margin: 0, fontSize: '9pt', fontWeight: '700', color: '#e74c3c' }}>{formatDate(data.dueDate)}</p>
            </div>
          </div>
        </div>

        {/* Styled Items Table */}
        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '25px' }}>
          <thead>
            <tr style={{ background: '#f8f9fa' }}>
              <th style={{ padding: '12px 15px', textAlign: 'left', fontSize: '8pt', textTransform: 'uppercase', color: '#2c3e50', borderBottom: '2px solid #2c3e50' }}>Description</th>
              <th style={{ padding: '12px 15px', textAlign: 'right', fontSize: '8pt', textTransform: 'uppercase', color: '#2c3e50', borderBottom: '2px solid #2c3e50' }}>Rate</th>
              <th style={{ padding: '12px 15px', textAlign: 'center', fontSize: '8pt', textTransform: 'uppercase', color: '#2c3e50', borderBottom: '2px solid #2c3e50' }}>Qty</th>
              <th style={{ padding: '12px 15px', textAlign: 'right', fontSize: '8pt', textTransform: 'uppercase', color: '#2c3e50', borderBottom: '2px solid #2c3e50' }}>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {(data.items || []).map((item, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '12px 15px', fontSize: '9.5pt', fontWeight: '600' }}>{item.desc}</td>
                <td style={{ padding: '12px 15px', textAlign: 'right', fontSize: '9pt', color: '#7f8c8d' }}>{data.currencySymbol}&nbsp;{Number(item.rate).toLocaleString()}/-</td>
                <td style={{ padding: '12px 15px', textAlign: 'center', fontSize: '9pt' }}>{item.qty}</td>
                <td style={{ padding: '12px 15px', textAlign: 'right', fontSize: '9.5pt', fontWeight: '700' }}>{data.currencySymbol}&nbsp;{(item.rate * item.qty).toLocaleString()}/-</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totals & Payments Section */}
        <div style={{ display: 'flex', gap: '30px' }}>
          <div style={{ flex: 1.2 }}>
            <h4 style={{ fontSize: '8pt', textTransform: 'uppercase', color: '#7f8c8d', marginBottom: '8px' }}>Recent Payments</h4>
            {(data.transactions || []).map((t, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', background: '#fcfcfc', border: '1px solid #eee', borderRadius: '4px', marginBottom: '4px' }}>
                <span style={{ fontSize: '8pt' }}>{formatDateT(t.date)} • {t.method}</span>
                <span style={{ marginLeft:'8pt', fontSize: '8pt', fontWeight: '700' }}>{data.currencySymbol}&nbsp;{Number(t.amount).toLocaleString()}/-</span>
              </div>
            ))}
            <div style={{ marginTop: '12px', padding: '8px 12px', borderRadius: '4px', borderLeft: '3px solid #3498db', background: '#ebf5fb' }}>
              <p style={{ margin: 0, fontSize: '8pt', color: '#2980b9', fontStyle: 'italic', lineHeight: '1.4' }}>{data.paidStatus}</p>
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
              <span style={{ color: '#7f8c8d', fontSize: '9pt', fontWeight: '600' }}>Subtotal</span>
              <span style={{ fontWeight: '600', fontSize: '9pt' }}>{data.currencySymbol}&nbsp;{subtotal.toLocaleString()}/-</span>
            </div>
            {data.discount > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', color: '#e74c3c' }}>
                <span style={{ fontSize: '9pt', fontWeight: '600' }}>Discount ({data.membershipType})</span>
                <span style={{ fontWeight: '600', fontSize: '9pt' }}>-{data.currencySymbol}&nbsp;{Number(data.discount).toLocaleString()}/-</span>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
              <span style={{ color: '#7f8c8d', fontSize: '9pt', fontWeight: '600' }}>VAT ({data.vatRate}%)</span>
              <span style={{ fontWeight: '600', fontSize: '9pt' }}>{data.currencySymbol}&nbsp;{vatAmount.toLocaleString()}/-</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '10px' }}>
              <span style={{ fontSize: '10pt', fontWeight: '900', textTransform: 'uppercase' }}>Grand Total:</span>
              <span style={{ fontSize: '12pt', fontWeight: '900', color: '#2c3e50' }}>{data.currencySymbol}&nbsp;{grandTotal.toLocaleString()}/-</span>
            </div>
          </div>
        </div>

        {/* Dynamic Settlement Section */}
        <div style={{ 
          marginTop: '25px', padding: '20px', 
          background: currentBalance <= 0 ? '#f8fafc' : 'transparent', 
          borderRadius: '8px', position: 'relative', overflow: 'hidden' 
        }}>
          {currentBalance <= 0 && (
            <div style={{
              position: 'absolute', right: '-10px', bottom: '-10px', fontSize: '80pt',
              fontWeight: '900', color: '#10b981', opacity: 0.05, pointerEvents: 'none',
              transform: 'rotate(-15deg)', userSelect: 'none'
            }}>PAID</div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', position: 'relative', zIndex: 1 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                <div style={{ 
                  width: '8px', height: '8px', borderRadius: '50%', 
                  background: currentBalance <= 0 ? '#10b981' : '#ef4444'
                }}></div>
                <span style={{ 
                  fontSize: '9pt', fontWeight: '800', textTransform: 'uppercase', 
                  letterSpacing: '1px', color: currentBalance <= 0 ? '#065f46' : '#991b1b' 
                }}>
                  {currentBalance <= 0 ? 'Transaction Settled' : 'Payment Outstanding'}
                </span>
              </div>
              {currentBalance <= 0 ? (
                <p style={{ margin: 0, fontSize: '8pt', color: '#64748b', maxWidth: '240px' }}>
                  Payment received in full. Thank you for your payments.
                </p>
              ) : (
                <p style={{ margin: 0, fontSize: '8pt', color: '#64748b' }}>
                  Please clear all the payments by <strong>{formatDate(data.dueDate)}</strong>.
                </p>
              )}
            </div>
            <div style={{ textAlign: 'right' }}>
              <p style={{ margin: 0, fontSize: '8pt', color: '#94a3b8', textTransform: 'uppercase', fontWeight: '700' }}>
                {currentBalance <= 0 ? 'Total Paid Amount' : 'Net Amount Due'}
              </p>
              <div style={{ 
                fontSize: '22pt', fontWeight: '900', color: currentBalance <= 0 ? '#065f46' : '#991b1b', lineHeight: '1.1'
              }}>
                <span style={{ fontSize: '14pt', verticalAlign: 'middle', marginRight: '2px' }}>{data.currencySymbol}</span>
                {(currentBalance <= 0 ? grandTotal : currentBalance).toLocaleString()}
                <span style={{ fontSize: '14pt', verticalAlign: 'middle' }}>/-</span>
              </div>
              {currentBalance <= 0 && (
                <div style={{ marginTop: '4px', display: 'inline-block', padding: '2px 8px', background: '#10b981', color: '#fff', fontSize: '7pt', fontWeight: '900', borderRadius: '2px', textTransform: 'uppercase' }}>
                  Paid in Full
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* FIXED SIGNATURE SECTION - Anchored above the footer bar */}
      <div style={{ 
        position: 'absolute', 
        bottom: '120px', 
        left: '0', 
        width: '100%', 
        padding: '0 20mm',
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-end',
        boxSizing: 'border-box'
      }}>
        <div>
          <p style={{ margin: '0 0 40px 0', fontSize: '8pt', color: '#7f8c8d', textTransform: 'uppercase' }}>Issued By</p>
          <div style={{ height: '45px', display: 'flex', alignItems: 'flex-end', marginBottom: '5px' }}>
            {data.signature && (
              <img src={data.signature} alt="Signature" style={{ maxHeight: '45px', maxWidth: '150px', objectFit: 'contain' }} />
            )}
          </div>
          <div style={{ borderBottom: '1.5px solid #2c3e50', width: '180px', marginBottom: '6px' }}></div>
          <p style={{ margin: 0, fontSize: '8pt', fontWeight: '900' }}>{data.directorName}</p>
          <p style={{ margin: 0, fontSize: '8.5pt', color: '#7f8c8d' }}>{data.directorTitle}</p>
          <p style={{ margin: 0, fontSize: '8.5pt', color: '#7f8c8d' }}>AURORA CREATIVES</p>
        </div>
        
        <div style={{ textAlign: 'right', fontSize: '7.5pt', color: '#bdc3c7', lineHeight: '1.4' }}>
          <p style={{ margin: 0 }}>This is a computer-generated document.</p>
          <p style={{ margin: 0 }}>Thank you for your order!</p>
        </div>
      </div>
      
      {/* FIXED BRANDED FOOTER BAR */}
      <div ref={ref} style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      
      {/* Top Contact Row: Clean white background with modern subtle separation */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        gap: '40px', 
        padding: '12px 0', 
        fontSize: '9.5pt', 
        fontWeight: '600', 
        color: '#1e293b',
        backgroundColor: '#ffffff',
        borderTop: '1px solid #f1f5f9',
        borderBottom: '1px solid #e2e8f0'
      }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '11pt', color: '#6200ff' }}>📞</span> +8801783509033
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '11pt', color: '#6200ff' }}>✉️</span> info@auroracreativesbd.com
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '11pt', color: '#6200ff' }}>🌐</span> www.auroracreativesbd.com
        </span>
      </div>

      {/* Main Branded Gradient Bar */}
      <div style={{ 
        background: 'linear-gradient(90deg, #2e1065 0%, #6200ff 35%, #7c3aed 70%, #994ae8 100%)',
        padding: '18px 24px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        color: '#ffffff'
      }}>
        
        {/* Left Section: Branding and Tagline */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {data?.companyFooter ? (
            <img 
              src={defaultLogo} 
              alt="Footer Logo" 
              style={{ 
                height: '28px', 
                maxWidth: '180px', 
                objectFit: 'contain', 
                filter: 'brightness(0) invert(1)' 
              }} 
            />
          ) : (
            <span style={{ fontWeight: '800', fontSize: '12pt', letterSpacing: '0.5px' }}>
              AURORA CREATIVES
            </span>
          )}
          
          {/* Visual Divider Line */}
          <div style={{ height: '16px', width: '1px', backgroundColor: 'rgba(255, 255, 255, 0.3)' }}></div>
          
          <span style={{ fontSize: '8pt', fontWeight: '500', opacity: 0.9, letterSpacing: '0.2px' }}>
            Crafting visual experiences where every pixel tells a story
          </span>
        </div>

        {/* Right Section: Address */}
        <div style={{ fontSize: '8pt', textAlign: 'right', opacity: 0.95 }}>
          <span style={{ fontWeight: '500' }}>
            Address: Shahjalal Avenue, Azampur Uttara, Dhaka - 1230, Bangladesh.
          </span> 
        </div>
      </div>
    </div>
  </div>
  );
});

export default InvoicePreview;